<template>
  <div class="status-tag">
    <el-tag v-if="label" size="mini" :type="value == 'M' ? 'primary' : 'info'">
      {{ label }}
    </el-tag>
  </div>
</template>

<script>
export default {
  props: {
    value: { type: String, default: '' },
    label: { type: String, default: '' },
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  font-size: 12px;
}
</style>
